// Storage and event key constants for the auth library

/** Fallback token expiry offset when MSAL does not return an expiresOn value (1 hour). */
export const DEFAULT_TOKEN_EXPIRY_MS = 3_600_000;

/** Stub session expiry offset used when authentication is globally disabled (1 year). */
export const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1_000;

export const AUTH_SESSION_STORAGE_KEY = 'conductor.auth.session';
export const AUTH_TOKEN_STORAGE_KEY = 'conductor.auth.token';
export const AUTH_LOGOUT_INTENT_KEY = 'conductor.auth.logoutIntent';
export const AUTH_BROADCAST_CHANNEL_KEY = 'conductor.auth.sync';
export const OFFLINE_USER_PROFILE_KEY = 'symphony.offline.userProfile';
export const OFFLINE_AUTHORIZATION_CONTEXT_KEY = 'symphony.offline.authorizationContext';

export const AUTH_EVENTS = {
  ACTIVITY: 'activity',
  LOGIN: 'login',
  LOGOUT: 'logout',
  TOKEN_REFRESHED: 'token-refreshed',
  SESSION_EXPIRED: 'session-expired',
  IDLE_WARNING: 'idle-warning',
} as const;

export type AuthEventType = (typeof AUTH_EVENTS)[keyof typeof AUTH_EVENTS];
